import { type FC, type ReactNode } from 'react';

import { Smokebreak } from '@wk/components-react16';
import { IconLoader2 } from '@tabler/icons-react';

import type { EvaluationCheckpoint } from '@/types';

import CheckpointStatusIcon from '../CheckpointStatusIcon';

interface CheckpointResultPanelsProps {
  checkpoint: EvaluationCheckpoint;
  isRemarksOpen: boolean;
  onCloseRemarks: () => void;
  isAiPanelOpen: boolean;
  onCloseAiPanel: () => void;
  aiLoading: boolean;
  aiResult: ReactNode;
}

const CheckpointResultPanels: FC<CheckpointResultPanelsProps> = ({
  checkpoint,
  isRemarksOpen,
  onCloseRemarks,
  isAiPanelOpen,
  onCloseAiPanel,
  aiLoading,
  aiResult,
}) => {
  return (
    <>
      <Smokebreak
        isOpen={isRemarksOpen}
        position="right"
        onUserRequest={onCloseRemarks}
      >
        <h2 slot="smokebreakHeader" className="p-3 text-lg font-semibold">
          Remarks
        </h2>
        <div slot="smokebreakBody" className="flex flex-col gap-4 px-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <CheckpointStatusIcon checkpoint={checkpoint} size={20} />
              <span className="text-gray-500">{checkpoint.status}</span>
            </div>
            <p className="text-gray-500">{checkpoint.remarks}</p>
          </div>
        </div>
      </Smokebreak>

      <Smokebreak
        isOpen={isAiPanelOpen}
        position="right"
        onUserRequest={onCloseAiPanel}
      >
        <h2 slot="smokebreakHeader" className="p-3 text-lg font-semibold">
          AI Analysis
        </h2>
        <div slot="smokebreakBody" className="flex flex-col gap-4 px-4 pb-8">
          {aiLoading ? (
            <div className="flex items-center gap-2 text-gray-500">
              <IconLoader2 className="animate-spin" size={18} />
              Running AI analysis...
            </div>
          ) : (
            <p className="whitespace-pre-wrap text-gray-500">
              {typeof aiResult === 'string'
                ? aiResult || 'No result available'
                : aiResult ?? 'No result available'}
            </p>
          )}
        </div>
      </Smokebreak>
    </>
  );
};

export default CheckpointResultPanels;
